/**
 * IDs of concepts from felles datakatalog
 */
export enum ConceptID {
  RETTSSTIFTELSE = '027752fe-61f6-4c6e-a89c-0559bf4fa4a3',
  DOKUMENTNUMMER = 'c74dd25c-6dbf-459c-837d-975248f3531c',
  INNKOMSTTIDSPUNKT = 'd450fe4a-ec4f-417b-b306-d1a8e5eeac76',
  BESLUTNINGSTIDSPUNKT = 'd67e55fd-642b-4a42-aef9-c00b8a64c1b9',
  PAATEGNING = '6a480542-1965-4435-901b-b5fa6a677623',
  PRIORITETSVIKELSE = '571aa4f6-40a2-4015-8a40-a3799a1ab357',
  GJELDSORDNINGSPERIODE = 'aa66b464-8420-48d9-b261-d0d2a1c2d9bf',
  FORMUESGODE = '25cc2478-276d-4e19-b924-e06aaef5baef',

  // Rolletyper (Key must be UPPERCASE rolletype)
  SAKSOKER = '354af1bd-ba56-42f7-a00a-a45e44e1b08c',
  SAKSOKT = '69199a8a-aea6-4315-88ef-444a6e63ffa4',
  NAMSMYNDIGHET = '07fe6a4e-2a6f-4e47-9b61-f92b9cf600ec',
  PROSESSFULLMEKTIG = '1c3c8d35-21d4-4b7e-a258-7c8958ccf9b4',
  PANTHAVER = '439f4b86-cd6a-4e0c-b427-965607db34e0',
  PANTSETTER = '106861d3-633d-4c54-b304-59cc30c42d61',
  OVERDRAGER = 'eb2083e6-ce16-4dba-8ff1-8e0242af9fc3',
  TILLITSMANN = 'b5d32b16-6619-4cb1-9710-37d1b83e90ec',
  ERVERVER = '17e0aa3c-0398-4ca8-aa7e-9d498c778ea6',
  KONKURSDEBITOR = 'a0116be5-ab0c-4681-88f8-e3d0d3290a4c',
  BOSTYRER = '58ba0bf3-675e-4c52-9eb9-5739b8acdd81',
  VERGEMALSMYNDIGHET = '85940927-468f-453d-864a-7a50b48d73f1',
  VERGE = '32b2c492-15ac-47a1-8eca-2ee310da8a95',
  FULLMAKTSGIVER = '315e8080-7425-44e9-b891-aef5ebe0572c',
  FULLMEKTIG = 'e2f88051-c13c-4688-8f1b-5be16d4ba69c',
  NAMSMANN = '07fe6a4e-2a6f-4e47-9b61-f92b9cf600ec',

  // Rettsstiftelsetyper
  UTP = '86ce563d-e291-45e1-869f-c269ff7acd86',
  SKU = '6e566274-99c7-4bea-a756-264dc8649f78',
  ARR = 'd763b159-ed9a-489a-9085-2f4f0b09ec41',
  SPH = 'e91e70af-224a-4354-a490-7635201910c6',
  SAP = '540988e7-9fed-4060-af23-d4afe0ff58a5',
  LEA = '675d0855-2d55-40c9-8576-598359cd012a',
  PDT = 'a3f2c9bf-9c63-46b9-90f2-44556f25e2a2',
  PVL = 'a3f2c9bf-9c63-46b9-90f2-44556f25e2a2',
  PLR = 'a3f2c9bf-9c63-46b9-90f2-44556f25e2a2',
  PFR = 'a3f2c9bf-9c63-46b9-90f2-44556f25e2a2',
  FAC = 'a3f2c9bf-9c63-46b9-90f2-44556f25e2a2',
  PMA = 'a3f2c9bf-9c63-46b9-90f2-44556f25e2a2',
  PBF = '5ac5f4f0-771e-4087-952b-1ee109d5b64f',
  KON = '907d8532-2076-4932-919c-21edd47133e7',
  GJO = 'feb46b24-4a2e-4d41-addb-0263c6a2894d',
  FRH = '85776e9a-dd84-439e-b154-5a137a1d5006',
  SFF = '37176e84-d977-4993-bc49-d76fcfc6e625',
  ABA = 'd26eeeba-53ff-4644-8741-ee56b5e2834d',

  UTT = '98856c7f-3475-4526-b2b4-c281a5b91ee8',
  ITU = '83719849-fb52-44d9-9a66-d48da4f0d9c2',
}

export const DefinitionFieldName: Record<string, 'remark' | 'text'> = {
  ARR: 'text',
  // BFF: '',
  // FRH: '',
  GJO: 'text',
  LEA: 'text',
  // LFN: '',
  PDT: 'text',
  PFR: 'text',
  FAC: 'text',
  PLR: 'text',
  // PMA: '',
  PVL: 'text',
  PBF: 'text',
  SAP: 'text',
  // SKU: '',
  SPH: 'remark',
  UTP: 'text',
};

export type ConceptIDKey = keyof typeof ConceptID;
export type DefinitionFieldNameKey = keyof typeof DefinitionFieldName;
